import React from 'react'

import RecipeParagraphMolecule  from '@/molecules/Paragraphs/RecipeParagraph'

const RecipeParagraph = (props) => (
  <RecipeParagraphMolecule {...props} />
)

export default RecipeParagraph
